import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://esernatttlwwdxbnoqen.supabase.co'; // Replace with your Supabase URL
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVzZXJuYXR0dGx3d2R4Ym5vcWVuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY3Njg0NzIsImV4cCI6MjA1MjM0NDQ3Mn0.8y33hjRFbS1qDiQqz3SbjT0fGeIHaAuneeKLvXGgPxc'; // Replace with your Supabase anon key

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);